import { ReactNode } from "react";

const BOLD_TAG = /<\/?b>/g;
const ANY_TAG = /<[^>]*>/g;

/** Only <b> and </b>, alternating, never nested, all closed. */
const isBalanced = (text: string): boolean => {
  const tags = text.match(ANY_TAG) ?? [];
  let open = false;
  for (const tag of tags) {
    if (tag !== "<b>" && tag !== "</b>") return false;
    const opening = tag === "<b>";
    if (opening === open) return false;
    open = opening;
  }
  return !open;
};

/**
 * Renders backend sentence text (P1D-5540). The only markup the API sends is
 * <b>…</b>, which becomes <strong>. Anything else, or unbalanced bold, renders as
 * plain text with every tag removed. Never injects HTML.
 */
const renderRichText = (text: string): ReactNode => {
  if (!isBalanced(text)) return text.replace(ANY_TAG, "");

  const parts: ReactNode[] = [];
  let bold = false;
  let index = 0;
  text.split(BOLD_TAG).forEach((segment, position, segments) => {
    if (segment) {
      parts.push(bold ? <strong key={index}>{segment}</strong> : segment);
      index += 1;
    }
    if (position < segments.length - 1) bold = !bold;
  });
  return parts;
};

export default renderRichText;
